import { useTranslation } from 'react-i18next'

import clsx from 'clsx'
import { nanoid } from 'nanoid'

import { Indicators } from 'entities/ticket/ui/card-of-ticket/ui/components/indicators'
import { IDirectionDetail } from 'entities/ticket/ui/direction-detail'
import { TransferDetail } from 'entities/ticket/ui/transfer-detail'

import { prepareTimeShow } from 'shared/lib/dateFormat'
import { AppIcon } from 'shared/ui/app-icon'
import { AllIcons } from 'shared/ui/app-icon/types'
import { Border } from 'shared/ui/border'
import { ImageLazy } from 'shared/ui/image-lazy'

import s from './styles.module.scss'

interface Props {
  direction?: number
  ticket: IDirectionDetail
}

const ShowDirection = ({
  index,
  direction,
  isDifficultRoute,
}: {
  index: number
  direction?: number
  isDifficultRoute?: boolean
}) => {
  const { t } = useTranslation()

  if (index !== 0) return null

  if (isDifficultRoute) return null

  return (
    <span
      className={clsx(
        s.name,
        'semi-bold-12',
        direction === 0 ? s.thereTag : s.returnTag,
      )}
    >
      {t(direction === 0 ? 'there' : 'return')}
    </span>
  )
}

export const OneSegmentFlight = ({ ticket, direction }: Props) => {
  const { t } = useTranslation()

  return ticket?.flyItems?.map((flyItem, index) => {
    return (
      <div
        key={nanoid()}
        className={s.container}
      >
        <div className={s.header}>
          <div className={s.left}>
            <ImageLazy
              className={s.airIcon}
              src={flyItem?.airPlane?.icon}
            />

            <div className={s.names}>
              <span className="medium-14">{`${t('flight')}: ${flyItem?.flight || ''}`}</span>
              <p className="semi-bold-16">{flyItem?.airPlane?.name}</p>
            </div>
          </div>

          <ShowDirection
            index={index}
            direction={direction}
            isDifficultRoute={ticket?.isDifficultRoute}
          />
        </div>

        <div className={s.depArrWrapper}>
          <div className={s.depArrDirection}>
            <div className={s.headerDirection}>
              <span className={clsx('extra-bold-18', s.city)}>
                {flyItem?.dep?.city || ''}
              </span>

              <span className={clsx('semi-bold-11', s.code)}>
                {flyItem?.dep?.code || ''}
              </span>
            </div>

            {(flyItem?.dep?.airport || flyItem?.dep?.terminal) && (
              <p className={clsx('medium-12', s.airport)}>
                {`${flyItem?.dep?.airport || ''} ${flyItem?.dep?.terminal && t('terminal', { terminal: flyItem?.dep?.terminal })}`}
              </p>
            )}
          </div>

          <div className={clsx(s.depArrDirection, s.right)}>
            <div className={clsx(s.headerDirection, s.textAlignRight)}>
              <span className={clsx('semi-bold-11', s.code)}>
                {flyItem?.arr?.code || ''}
              </span>

              <span className={clsx('extra-bold-18', s.city)}>
                {flyItem?.arr?.city || ''}
              </span>
            </div>

            <p className={clsx('medium-12', s.airport)}>
              {`${flyItem?.arr?.airport || ''} ${flyItem?.arr?.terminal && t('terminal', { terminal: flyItem?.arr?.terminal })}`}
            </p>
          </div>
        </div>

        <Border />

        <div className={s.direction}>
          <div className={s.left}>
            <p className={clsx('extra-bold-18', s.time)}>
              {flyItem?.dep?.time}
            </p>
            <p className={clsx('medium-12', s.date)}>{flyItem?.dep?.date}</p>
          </div>

          <div className={s.center}>
            <AppIcon
              width={16}
              height={16}
              id={AllIcons.AIRLINE_RATING}
              color="var(--link)"
            />

            {Boolean(flyItem?.airPlane?.timeFly) && (
              <span className={clsx('semi-bold-12', s.timeFlight)}>
                {t('time_transfer', {
                  duration: prepareTimeShow(flyItem?.airPlane?.timeFly),
                })}
              </span>
            )}
          </div>

          <div className={s.right}>
            <p className={clsx('extra-bold-18', s.time)}>
              {flyItem?.arr?.time}
            </p>
            <p className={clsx('medium-12', s.date)}>{flyItem?.arr?.date}</p>
          </div>
        </div>

        <Border />

        {/* <div className={clsx('regular-12', s.baggageInfo)}>
          <span>
            {flyItem?.baggage
              ? `${t('baggage')}: ${flyItem?.baggage || ''} ${t('kg')}`
              : t('without_baggage_capital')}
          </span>

          <span>
            {flyItem?.cbaggage
              ? `${t('hand_baggage')}: ${flyItem?.cbaggage || ''} ${t('kg')}`
              : t('without_cbaggage_capital')}
          </span>

          {flyItem?.class && <span>{flyItem.class}</span>}
        </div> */}

        <Indicators baggageInfo={flyItem?.baggageInfo} />

        {flyItem.transfer && <TransferDetail {...flyItem.transfer} />}
      </div>
    )
  })
}
